import { PVFileDurationRef, PVFileFormatRef, PVFileStepRef } from '@/dto/scenario/pv/PVReference';
import { PVFile } from '@/dto/scenario/pv/PVFile';
import { DtoExt } from '@/classes/scenario/DtoExt';
import { startOf } from '@/helpers/timeHelper';

export class PVFileExt extends DtoExt {

  public static fromDto(dto: PVFile): PVFileExt {
    return new PVFileExt({
      formatRef: dto.formatRef,
      durationRef: dto.durationRef,
      stepRef: dto.stepRef,
      startDate: dto.startDate && DtoExt.localeDateFromUtc(dto.startDate),
      name: dto.name,
      values: dto.values,
      simulatedPVCapacity: dto.simulatedPVCapacity
    } as any);
  }

  public formatRef: PVFileFormatRef | null = null;

  public durationRef: PVFileDurationRef | null = null; // NOT CURRENTLY FED

  public stepRef: PVFileStepRef | null = null; // NOT CURRENTLY FED

  public startDate: Date | null = startOf(2018);

  public name: string | null = null;

  public values: number [] | null = null;

  public simulatedPVCapacity: number | null = null;

  constructor(options?: Partial<PVFileExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): PVFile {
    return new PVFile({
      formatRef: this.formatRef,
      durationRef: this.durationRef,
      stepRef: this.stepRef,
      startDate: DtoExt.localeDateToUtc(this.startDate),
      name: this.name,
      values: this.values,
      simulatedPVCapacity: this.simulatedPVCapacity
    });
  }
}
